module.exports = __webpack_public_path__ + "nucleo-outline.53a1bed7a3ec86d010fe.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/Pablo/source/repos/prote/angular/src/assets/fonts/nucleo-outline.eot
// module id = ../../../../../src/assets/fonts/nucleo-outline.eot
// module chunks = 17